<img class="pointercl" [src]="Menu.FotoUrl" alt="Afdruk" width="70" height="70" class="center" (click)="onclick(Menu)">
<div>
    <h5 class="text-uppercase text-strong text-center text-s-size-12 pointercl" (click)="onclick(Menu)">{{translate(Menu)}}</h5>
    <a class="text-more-info text-aqua-hover text-center pointercl" (click)="onclick(Menu)">{{translateString('Klik hier')}}</a>
    <!--<a class="text-more-info text-aqua-hover text-center pointercl">e-catalogus</a>-->
</div>